import { render } from "./Agenti.vue?vue&type=template&id=b2c4557e"
import script from "./Agenti.vue?vue&type=script&lang=js"
export * from "./Agenti.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEV\\SHIRE\\nic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__